export const prUrl = `https://mt.osintsee.com/?murl=`
export const minioHost = "http://103.59.148.166:9000/"

export const osintRequestAddress = 'https://www.osintsee.com'
// export const oneSixSixRequestAddress = 'http://103.59.148.166:8083'
export const oneSixSixRequestAddress = 'https://www.osintsee.com'